import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=68dd25fe"
import script from "./Bookings.vue?vue&type=script&lang=ts"
export * from "./Bookings.vue?vue&type=script&lang=ts"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=68dd25fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports